/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, Input, OnInit } from '@angular/core';
import {
  EquisButtonBaseSizes,
  EquisAnchorType as Target,
} from '@tn-equis/core/components/button';

import { ILink } from './link.types';
import { SectionService } from '../../services/section.service';
import { PlatformService } from '../../services/platform.service';
import { mapStyle, getWidth } from '../../utils/link';

@Component({
  selector: 'nx-link',
  templateUrl: './link.component.html',
})
export class LinkComponent implements ILink, OnInit {
  constructor(
    private section: SectionService,
    private platform: PlatformService,
  ) {}

  // REQUIRED INPUTS
  @Input() data!: ILink['data'];
  // OPTIONAL INPUTS
  @Input() width?: ILink['width'] = 'full';
  @Input() size: ILink['size'] = EquisButtonBaseSizes.LARGE;

  // PROPERTIES
  absoluteHref!: string;

  /**
   * Gets the button style, based on the style input.
   */
  get buttonStyle() {
    return mapStyle(this.data.style);
  }

  /**
   * Anchor type for the Link button.
   */
  get target() {
    return this.data.opensNewTab ? Target._BLANK : Target._SELF;
  }

  get buttonWidth() {
    return getWidth(this.width);
  }

  // HOOKS
  ngOnInit(): void {
    this.absoluteHref = this.platform.getAbsoluteURL(this.data.url);
  }
}
